import aufb from "../../assets/images/Customer/aufb.svg";
import auin from "../../assets/images/Customer/auin.svg";
import auzl from "../../assets/images/Customer/auzl.svg";

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

export default function StoryAuthor({ banner, categories, caseStudy }) {
  return (
    <div className="w-full">
      {caseStudy && (
        <div className="w-full mx-auto container px-[20px] py-[20px] flex flex-col gap-3 md:flex-col md:gap-4">
          <div>
            <p className="text-[28px] text-[#053CC8] font-semibold"></p>
          </div>
          <div>
            <img
              src={banner}
              alt="ffr"
              className="block md:hidden w-full h-auto object-cover"
            />
            <img
              src={banner}
              alt="vvf"
              className="hidden md:block w-full h-auto object-cover"
            />
          </div>
          <div className="w-full flex flex-col gap-3 md:flex-row items-center">
            <div className="w-full flex justify-between items-center">
              <div className="w-full flex flex-col gap-1">
                <p className="text-[16px] text-[#606060] font-medium">
                  Tác giả
                </p>
                <p className="text-[16px] text-[#053CC8] font-medium">
                  {caseStudy.author}
                </p>
              </div>
              <div className="w-px h-16 bg-gray-300"></div>

              <div className="w-full flex flex-col gap-1 pl-10">
                <p className="text-[16px] text-[#606060] font-medium">
                  Đăng ngày
                </p>
                <p className="text-[16px] text-[#053CC8] font-medium">
                  {new Date(caseStudy.publishDate).toLocaleDateString()}
                </p>
              </div>
            </div>
            <div className="w-px h-16 bg-gray-300 hidden md:block"></div>
            <div className="w-full flex justify-between items-center">
              <div className="w-full flex flex-col gap-1">
                <p className="text-[16px] text-[#606060] font-medium">Chủ đề</p>
                <p className="w-[140px] text-[16px] text-[#053CC8] font-medium md:w-[190px] lg:whitespace-nowrap">
                  {getCategoryName(categories, caseStudy.categories)}
                </p>
              </div>
              <div className="w-px h-16 bg-gray-300"></div>

              <div className="w-full flex flex-col gap-1 pl-10">
                <div>
                  <p className="text-[16px] text-[#606060] font-medium">
                    Chia sẻ
                  </p>
                </div>
                <div className="w-full flex items-center gap-2">
                  <img src={aufb} alt="bfdb" />
                  <img src={auin} alt="svs" />
                  <img src={auzl} alt="cds" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
